<script setup lang="ts">
interface Props {
  color?: string
  content?: string | number
  dot?: boolean
}

withDefaults(defineProps<Props>(), {
  color: 'primary',
  content: '',
  dot: false,
})
</script>

<template>
  <v-badge
    :color="color"
    :content="dot ? undefined : content"
    :dot="dot"
  >
    <slot />
  </v-badge>
</template>

<style scoped lang="scss">
</style>
